// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__ia8ZI","content":"LayoutSettings_content__1c9uE"};